import gql from "graphql-tag";
import { Apollo } from "@/decorators";

import COMPANY_TAG_QUERY from "../graphql/tag/PartitionTagsCompany.gql";

import { getCompanyTags, computeCompanyCommonTags } from "../services/tagServices";
import { NotificationBase } from "./NotificationBase";
import { Component } from "vue-facing-decorator";

@Component({
    name: "ComponentBase"
})
export class ComponentBase extends NotificationBase {
    //
    // Company
    //
    get selectedCompany() {
        return null;
    }

    get activateTagguing() {
        return false;
    }
    //
    // free tagguing
    //

    partitionTags = [];

    @Apollo({
        query() {
            return COMPANY_TAG_QUERY;
        },
        variables() {
            return {
                companyId: this.selectedCompany.id,
            };
        },
        skip() {
            return !this.activateTagguing || !this.selectedCompany?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                // debugger
                this.companyTags = [];
                if (data.tags) {
                    // debugger
                    getCompanyTags(this, this.selectedCompany.id, data.tags, this.companyTags);
                }
                this.partitionTags = data.partitionTags || [];
            }
        },
    })
    companyTags = [];

    @Apollo({
        query: gql`
            query partitionTags($uniqueNames: [String!]!) {
                partitionTags(where: { uniqueName_in: $uniqueNames }) {
                    id
                    uniqueName
                    name
                    tags {
                        id
                        name
                        type
                        primaryLog
                    }
                }
            }
        `,
        skip() {
            return !this.activateTagguing;
        },
        variables() {
            return {
                //uniqueNames: ["Fixe_Variable", "genericPurchase", "genericSales", "folder"]
                uniqueNames: ["folder"],
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.partitionTags && data.partitionTags.length) {
                    this.commonCompanyTags = [];
                    computeCompanyCommonTags(data.partitionTags, this.commonCompanyTags);
                } else {
                    this.commonCompanyTags = [];
                }
            }
        },
    })
    commonCompanyTags: any[] = [];

    get allCompanyTags() {
        if (this.commonCompanyTags?.length) {
            const allTags = [...this.companyTags, ...this.commonCompanyTags];
            return allTags;
        }
        return this.companyTags;
    }
}
